import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { ApiService } from '../../../../../shared/services/api.service';
import { A, co } from '@fullcalendar/core/internal-common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';



@Component({
  selector: 'app-update-event-date-popup',
  templateUrl: './update-event-date-popup.component.html',
  styleUrl: './update-event-date-popup.component.css',
})
export class UpdateEventDatePopupComponent {
  form!: FormGroup;
  EventId:any;

  constructor(
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private apiService: ApiService,
    public dialogRef: MatDialogRef<UpdateEventDatePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    console.log(this.data);
    console.log('Received Data:', this.data.FormatedEventDate);
     this.EventId= this.data.EventId;
    const dateStr = this.data.FormatedEventDate;
    let time = '';
    if (dateStr && dateStr.includes('@')) {
      const rawTime = dateStr.split('@')[1].trim(); // "1:00 AM"
      time = this.convertTo24Hour(rawTime); // ✅ "01:00"
    }
    this.form = this.fb.group({
      eventDate: [this.data.EventDate, Validators.required],
      eventTime: [time, Validators.required],
      Remark: ['', Validators.required],
    });

    if (this.data?.updatedEventDate || this.data?.EventDate) {
      const dateValue = this.data.updatedEventDate || this.data.EventDate;
      this.form.patchValue({
        eventDate: new Date(dateValue),
      });
    }
  }
  minDate: Date = new Date(2025, 3, 1);
  selectedFile: File | null = null;
  selectedFileName: string = '';
  updatedEventDate: any;

  onFileSelect(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      this.selectedFileName = file.name;
    }
  }

  clearFile() {
    this.selectedFile = null;
    this.selectedFileName = '';
  }

  convertTo24Hour(timeStr: string): string {
    const [time, modifier] = timeStr.split(' ');
    let [hours, minutes] = time.split(':');

    if (modifier === 'PM' && hours !== '12') {
      hours = String(+hours + 12);
    }
    if (modifier === 'AM' && hours === '12') {
      hours = '00';
    }

    return `${hours.padStart(2, '0')}:${minutes}`;
  }

  onDateChange(event: any) {
    const selectedDate = event.value;

    console.log('Selected Date:', selectedDate);
    this.updatedEventDate = selectedDate;
  }

  save() {
    if (this.form.invalid) return;


    const selectedDate = this.form.value.eventDate;
    const selectedTime = this.form.value.eventTime;
    const selectedRemark = this.form.value.Remark;

    console.log('Selected Date:', selectedDate);
    console.log('Selected Time:', selectedTime);
    console.log('Selected Remark:', selectedRemark);

    const dateObj = new Date(selectedDate);


    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();

    const formattedTimechk = this.convertToAMPM(selectedTime);


    // ✅ Use formattedTime (AM/PM)
    const formattedDatechk = `${day}/${month}/${year} @${formattedTimechk}`;

    console.log('Formatted Selected:', formattedDatechk);
    console.log('Existing:', this.data.FormatedEventDate);

    // ✅ Now comparison will work
    if (formattedDatechk === this.data.FormatedEventDate) {
      this.toastrService.warning('No changes detected. Date and time are same.');
      return;
    }

    // ✅ Validate date
    if (!selectedDate) {
      this.toastrService.error('Invalid date');
      return;
    }

    const date = new Date(selectedDate);

    if (isNaN(date.getTime())) {
      this.toastrService.error('Invalid date format');
      return;
    }

    // ✅ Validate time
    if (!selectedTime) {
      this.toastrService.error('Time is required');
      return;
    }

    // ✅ Convert time
    const formattedTime = this.convertToAMPM(selectedTime);

    // format date as YYYY-MM-DD (no timezone issue)
    const formattedDate =
      date.getFullYear() +
      '-' +
      String(date.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(date.getDate()).padStart(2, '0');

    // 🔥 Use FormData
    const formData = new FormData();

    formData.append('UniqueEventId', this.data.UniqueEventId);
    // formData.append('UpdatedEventDate',date.toISOString());
    formData.append('UpdatedEventDate', formattedDate);
    formData.append('UpdatedEventTime', formattedTime);
    formData.append('Remark', selectedRemark || '');

    // ✅ File is optional
    if (this.selectedFile) {
      formData.append('File', this.selectedFile);
    }

    console.log('Payload (FormData):', formData);

    this.apiService
      .postRequest(API_ENDPOINTS.MSSIDC.UPDATEEVENTDATE, formData)
      .subscribe({
        next: (res: any) => {
          if (res.status || res.Status === 1) {
            this.toastrService.success('Event date updated sucessfully');
            this.dialogRef.close(true);
          } else {
            this.toastrService.error(res.message || 'Update failed');
          }
        },
        error: (err) => {
          console.error(err);
          this.toastrService.error('Something went wrong');
        },
      });
  }


  convertToAMPM(time: string): string {
    if (!time) return '';

    const [hoursStr, minutes] = time.split(':');

    let hours = parseInt(hoursStr, 10);

    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours ? hours : 12; // 0 → 12

    const hh = hours.toString().padStart(2, '0');

    return `${hh}:${minutes} ${ampm}`;
  }

  close() {
    this.dialogRef.close();
  }
}
